import React, { useRef } from "react";
import { Button, Card, Divider, Dropdown, Menu, Modal } from "antd";
import OrderDetailList from "./OrderDetailList";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import OrderForm from "./OrderForm";
import { useModel, useModelDispatchers } from "../../../models";
import { useHistory } from "react-router";
import { goPage } from "../../layout/pageDefinition";
import UpOutlined from "@ant-design/icons/lib/icons/UpOutlined";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import OrderPrint from "./OrderPrint";
import OrderPrint1 from "./OrderPrint1";
import { debounce } from "lodash";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const history = useHistory();
    const formRef = useRef();
    const printRef = useRef();
    const printRef1 = useRef();
    const { closeNav } = useModelDispatchers("nav");
    const [{
        selectedDocument,
        formExpand
    }, {
        disable,
        shift,
        toggleExpand,
        loadOrder
    }] = useModel("saleOrder");
    const [{ preview }, { setPreview }] = useModel("global")

    const { loadSo } = useModelDispatchers("saleSo");

    if (!selectedDocument.hasOwnProperty("id")) {

    }
    const { orderStatus } = selectedDocument;

    const getForm = () => {
        return formRef && formRef.current ? formRef.current.form() : null
        // return formRef.current.form();
    };

    const onPrint = () => {
        setPreview({
            visible: true,
            __html: printRef.current.dom().innerHTML
        })
    }
    const onPrint1 = () => {
        setPreview({
            visible: true,
            __html: printRef1.current.dom().innerHTML
        })
    }
    const onDisable = () => {
        Modal.confirm({
            title: "确认作废此单据？",
            centered: true,
            closable: true,
            onOk: () => {
                const { id: data } = selectedDocument;
                disable({ showMsg: true, data });
            },
            onCancel: () => { }
        });
    }
    const onShift = () => {
        const { id: data } = selectedDocument;
        shift({ showMsg: true, data }).then(ret => {
            //加载销售单
            loadSo({ showMsg: false, data: ret }).then(() => {
                goPage(history, "3-2-1");
            });
        });
    }
    const onSave = () => {
        formRef.current.update();
    }

    const onBack = () => {
        closeNav();
        goPage(history, "3-1");
    }
    const onRefresh = async () => {
        const { id } = selectedDocument;
        await loadOrder({ showMsg: true, data: id })
    }
    const onToggleExpand = () => {
        toggleExpand();
    }
    const printStyleMenu = (
        <Menu>
            <Menu.Item key="1" onClick={onPrint}>服务站样式</Menu.Item>
            <Menu.Item key="2" onClick={onPrint1}>普通样式</Menu.Item>
        </Menu>
    );

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">销售订单</span>
                    <span className="margin-left-16">
                        {selectedDocument.saleOrderCode}
                        [{selectedDocument.orderStatusName}]
                    </span>
                    <span
                        className="margin-left-16"
                        onClick={onToggleExpand}
                        style={{ cursor: "pointer" }}
                    >
                        {formExpand ? <UpOutlined /> : <DownOutlined />}
                    </span>
                </h3>
                <div style={{ width: "600px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_CANCEL}>
                        <Button
                            onClick={onDisable}
                            disabled={orderStatus !== "014001"}
                        >作废
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_PRINT}>
                        <Dropdown className="margin-left-8" overlay={printStyleMenu}>
                            <Button>
                                打印 <DownOutlined />
                            </Button>
                        </Dropdown>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_TRANS}>
                        <Button
                            className="margin-left-8"
                            onClick={debounce(onShift, 600)}
                            disabled={
                                orderStatus === "014002"
                                || orderStatus === "014003"
                            }
                        >转销售单
                    </Button>
                    </YhAuth>
                    <Button
                        className="margin-left-8"
                        onClick={debounce(onRefresh, 600)}
                    > 刷新
                    </Button>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_SAVE}>
                        <Button
                            className="margin-left-8"
                            type="primary"
                            onClick={debounce(onSave, 600)}
                            disabled={
                                orderStatus === "014002"
                                || orderStatus === "014003"
                            }
                        >
                            保存
                    </Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onBack}>返回</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <OrderForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
            <Divider orientation="left" />
            <OrderDetailList getForm={getForm} />

            <OrderPrint printRef={printRef} />
            <OrderPrint1 printRef={printRef1} />
        </Card>
    );
}